import { render, staticRenderFns } from "./CompanyAnswerCompare.vue?vue&type=template&id=752b0777"
import script from "./CompanyAnswerCompare.vue?vue&type=script&lang=js"
export * from "./CompanyAnswerCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports